const PACKING_MACHINE_URL = process.env.REACT_APP_API_PATH || "http://localhost:54229";

class WarehouseMessagesClient {
  query = async (
    entityType: number,
    entityId: number,
    recipientType?: number | null,
    recipientId?: number | null,
    unackOnly?: number | null,
  ): Promise<any[]> => {
    const params = new URLSearchParams();
    params.set("entityType", entityType.toString());
    params.set("entityId", entityId.toString());
    if (recipientType != null) params.set("recipientType", recipientType.toString());
    if (recipientId != null) params.set("recipientId", recipientId.toString());
    if (unackOnly != null) params.set("unacknowledgedOnly", unackOnly.toString());

    const url = `${PACKING_MACHINE_URL}/api/warehouse-messages?${params.toString()}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const text = await response.text().catch(() => response.statusText);
      throw new Error(`Failed to fetch warehouse messages (${response.status}): ${text}`);
    }

    return await response.json();
  };

  acknowledge = async (messageId: number): Promise<void> => {
    const url = `${PACKING_MACHINE_URL}/api/warehouse-messages/${messageId}/ack`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const text = await response.text().catch(() => response.statusText);
      throw new Error(`Failed to acknowledge message (${response.status}): ${text}`);
    }

    // API returns Ok() with no body — do not attempt to parse JSON.
    return;
  };
}

const warehouseMessagesClient = new WarehouseMessagesClient();
export default warehouseMessagesClient;